import { GTMolecularImportFn } from "../../components/GTMolecularImportFn";

const FN_NAME = "gtm-import-kits-received";

function FnRun() {
  return <GTMolecularImportFn name={FN_NAME} />;
}

export { FnRun };
